import { commentsItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              读者热评
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              吃瓜群众怎么说？来看看大家的真实反馈
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {commentsItems.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-sm font-bold flex-shrink-0">
                    {comment.avatar}
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                    <div className="text-xs text-foreground-400">{comment.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {comment.text}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}